import * as actionTypes from "./actionTypes";

export const initializeValues = payload => ({
  type: actionTypes.initializeValuesType,
  payload
});

export const changeAccountType = payload => ({
  type: actionTypes.changeAccountType,
  payload
});

export const changeAddress = payload => ({
  type: actionTypes.changeAddressType,
  payload
});

export const changeAddressValue = payload => ({
  type: actionTypes.changeAddressValueType,
  payload
});

export const changeAccountNumber = payload => ({
  type: actionTypes.changeAccountNumberType,
  payload
});

export const changeFundDetails = payload => ({
  type: actionTypes.changeFundDetailsType,
  payload
});

export const checkVGMutualFund = payload => ({
  type: actionTypes.checkVGMutualFundType,
  payload
});

export const addMutualFund = payload => ({
  type: actionTypes.addMutualFundType,
  payload
});

export const addnewFundDetails = payload => ({
  type: actionTypes.addnewFundDetailsType,
  payload
});

export const clearfundDetails = payload => ({
  type: actionTypes.clearfundDetailsType,
  payload
});

export const removeFundInfo = payload => ({
  type: actionTypes.removeFundInfoType,
  payload
})

export const updateAOAccountNumber = payload => ({
  type: actionTypes.updateAOAccountNumberType,
  payload
});

export const getZipCode = payload => ({
  type: actionTypes.getZipCodeType,
  payload
});

export const updateLoggedinAddress = payload => ({
  type: actionTypes.updateLoggedinAddressType,
  payload
});

export const allocationPreference = payload => ({
  type: actionTypes.allocationPreferenceType,
  payload,
});

export const UpdateFormInReducer = payload => ({
  type: actionTypes.UpdateFormInReducerType,
  payload,
});

export const resetAllocationPools = () => ({
  type: actionTypes.resetAllocationPoolsType,
});

export const switchExchangeUnit = payload => ({
  type: actionTypes.switchExchangeUnitType,
  payload,
});

export const updateFromTotal = payload => ({
  type: actionTypes.updateFromTotalType,
  payload,
});

export const updateFromFormField = payload => ({
  type: actionTypes.updateFromFormFieldType,
  payload,
});

export const updateRecordedVal = payload => ({
  type: actionTypes.updateRecordedValType,
  payload,
});

export const clearFormData = payload => ({
  type: actionTypes.clearFormDataType,
  payload
});

export const removeContributionType = payload => ({
  type: actionTypes.removeContributionType,
  payload
});

export const getAPIData = payload => ({
  type: actionTypes.getAPIDataType,
  payload
});

export const createContribution = payload => ({
  type: actionTypes.createContributionType,
  payload
});

export const updateContributionError = payload => ({
  type: actionTypes.updateContributionErrorType,
  payload
});

export const updateContributionStatus = payload =>({
  type: actionTypes.updateContributionStatusType,
  payload
});
 
export const updateContributionStatusJson = payload =>({
  type: actionTypes.updateContributionStatusJsonType,
  payload
});

export const generateAccesKey = payload => ({
  type: actionTypes.generateAccesKeyType,
  payload
});

export const step1Edit = payload => ({
  type: actionTypes.step1EditType,
  payload
});

export const updateClearStatus = payload => ({
  type: actionTypes.updateClearStatusType,
  payload
});

export const updateAutoFilledStatus = payload => ({
  type: actionTypes.updateAutoFilledStatusType,
  payload
});

export const showErrorMessages = payload => ({
  type: actionTypes.showErrorMessagesType,
  payload
});

export const updateErrorMessage = payload => ({
  type: actionTypes.updateErrorMessageType,
  payload
});

export const updateAdditionalData = payload => ({
  type: actionTypes.updateAdditionalDataType,
  payload
});

export const updateZipCodeValues = payload => ({
  type: actionTypes.updateZipCodeValuesType,
  payload
});

export const updateZipCodeErrorMessage = payload => ({
  type: actionTypes.updateZipCodeErrorMessageType,
  payload
});

export const updateSelectedTicker = payload => ({
  type: actionTypes.updateSelectedTickerType,
  payload
});

export const fetchTickerSuggestion =  payload => ({
  type: actionTypes.fetchTickerType,
  payload
});

export const fetchUnitPrice = payload =>({
   type: actionTypes.fetchPriceType,
   payload
})
export const clearPrice = payload =>({
    type: actionTypes.clearPriceType,
   payload
})